export enum applicationsTypes {
  FETCH_APPLICATIONS_REQUEST = "FETCH_APPLICATIONS_REQUEST",
  FETCH_APPLICATIONS_SUCCESS = "FETCH_APPLICATIONS_SUCCESS",
  FETCH_APPLICATIONS_FAILURE = "FETCH_APPLICATIONS_FAILURE",
}